import React from 'react';
import { MessageCircle, ClipboardCheck, Truck } from 'lucide-react';
import { steps } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const iconMap = {
  MessageCircle: MessageCircle,
  ClipboardCheck: ClipboardCheck,
  Truck: Truck,
};

const HowItWorks = () => {
  const [titleRef, titleVisible] = useScrollAnimation(0.1);
  const [stepsRef, stepsVisible] = useScrollAnimation(0.1);

  return (
    <section id="como-funciona" className="py-20 bg-white relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#1FA2FF]/5 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '6s' }}></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0077C8]/5 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '7s' }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div
          ref={titleRef}
          className={`text-center mb-16 ${titleVisible ? 'animate-fade-in-up' : 'animate-on-scroll'}`}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-[#071028] mb-4">
            Como Funciona
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Processo simples e transparente em 3 passos
          </p>
        </div>

        <div ref={stepsRef} className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#1FA2FF] via-[#0077C8] to-[#1FA2FF] -translate-y-1/2 mx-32 animated-gradient"></div>

          <div className="grid lg:grid-cols-3 gap-12 relative">
            {steps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div
                  key={step.id}
                  className={`relative ${stepsVisible ? 'animate-scale-in' : 'animate-on-scroll'} delay-${index + 1}00`}
                >
                  {/* Step Card */}
                  <div className="bg-gradient-to-br from-[#D1E9FF] to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 group hover-lift h-full flex flex-col">
                    {/* Step Number */}
                    <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-gradient-to-br from-[#1FA2FF] to-[#0077C8] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg group-hover:scale-125 group-hover:rotate-12 transition-all duration-300">
                      {index + 1}
                    </div>

                    {/* Icon */}
                    <div className="flex justify-center mb-6 mt-4">
                      <div className="w-20 h-20 bg-white rounded-2xl shadow-md flex items-center justify-center group-hover:scale-125 group-hover:rotate-6 transition-all duration-500">
                        <Icon className="w-10 h-10 text-[#1FA2FF] group-hover:text-[#0077C8] transition-colors duration-300" />
                      </div>
                    </div>

                    {/* Content */}
                    <h3 className="text-2xl font-bold text-[#071028] text-center mb-4 group-hover:text-[#1FA2FF] transition-colors duration-300">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-center leading-relaxed">
                      {step.description}
                    </p>

                    {/* Decorative corner */}
                    <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-[#1FA2FF]/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
